import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useGlobalState } from '@/global-state/useGlobalState';
import AllVariablesToggle from './AllVariablesToggle';
const AllVariablesToggleContainer = () => {
  const $ = _c(6);
  const isShowingAll = useGlobalState(_temp);
  const setShowingAll = useGlobalState(_temp2);
  let t0;
  let t1;
  if ($[0] !== setShowingAll) {
    t0 = () => () => setShowingAll(false);
    t1 = [setShowingAll];
    $[0] = setShowingAll;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== isShowingAll || $[4] !== setShowingAll) {
    t2 = <AllVariablesToggle checked={isShowingAll} onCheckedChange={setShowingAll} />;
    $[3] = isShowingAll;
    $[4] = setShowingAll;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default AllVariablesToggleContainer;
function _temp(state) {
  return state.isShowingAll;
}
function _temp2(state_0) {
  return state_0.setShowingAll;
}